import { render, staticRenderFns } from "./identifier_create_bulk.vue?vue&type=template&id=657fe868"
import script from "./identifier_create_bulk.vue?vue&type=script&lang=js"
export * from "./identifier_create_bulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports